export const namespaced = true

export const state = {
  online: true
}

export const mutations = {
  SET_ONLINE_STATUS(state, status) {
    state.online = status
  }
}

export const actions = {
  setOnlineStatus({ commit, dispatch }, status) {
    commit('SET_ONLINE_STATUS', status)
    var notification

    if (status) {
      notification = {
        type: 'success',
        message: 'Connected'
      }
    } else {
      notification = {
        type: 'error',
        message: 'You are currently offline.'
      }
    }

    dispatch('notification/add', notification, { root: true })
  }
}

export const getters = {}
